import { Pipe, PipeTransform } from '@angular/core';
import { declarationAppUrls, notificationAppUrls } from '../app.routes';

@Pipe({
  name: 'applicationSignActionName',
  standalone: true
})
export class ApplicationSignActionNamePipe implements PipeTransform {

  transform(value?: string | null): string {
    switch (true) {
      case declarationAppUrls.includes(value || ''): {
        return 'Podpisz deklaracje';
      }
      case notificationAppUrls.includes(value || ''): {
        return 'Podpisz zgłoszenie';
      }
      default: {
        return 'Podpisz wniosek';
      }
    }
  }

}
